import { get, getAuthenticatedRequestConfig } from '../client'
import { notificationsTotalUnreadSerializer } from '../../serializers/notificationsTotalUnreadSerializer'

export const getNotificationsTotalUnreadResource = (params = {}) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  get('/v1/notifications/unread_count', { ...params })
    .then((response) => notificationsTotalUnreadSerializer(response))
    .catch((error) => Promise.reject(error))

export const getAuthenticatedNotificationsTotalUnreadResource = (
  baseURL,
  authToken,
  authHeader,
  authScheme,
  params = {}
) => {
  const requestConfig = getAuthenticatedRequestConfig(
    baseURL,
    authToken,
    authHeader,
    authScheme,
    params
  )

  return getNotificationsTotalUnreadResource(requestConfig)
}

export default getNotificationsTotalUnreadResource
